module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerBar-title-wrapper col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "fields-wrapper col-xs-12 col-sm-12 col-md-10 col-lg-10 pull-right px-0"
  }, [_vm._t("fields")], 2), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [(_vm.subTitle) ? _c('h4', {
    staticClass: "subtitle-headerBar"
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d6d05cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d6d05cc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/headerBar/headerBar.pug
// module id = 1365
// module chunks = 0